'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var Glyph = require('./Glyph');
var Mixin = require('../mixin');

var CalendarView = (function (_React$Component) {
    _inherits(CalendarView, _React$Component);

    function CalendarView() {
        _classCallCheck(this, CalendarView);

        _get(Object.getPrototypeOf(CalendarView.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(CalendarView, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'table',
                null,
                _react2['default'].createElement(
                    'colgroup',
                    null,
                    _react2['default'].createElement('col', { width: '14.29%' }),
                    _react2['default'].createElement('col', { width: '14.29%' }),
                    _react2['default'].createElement('col', { width: '14.29%' }),
                    _react2['default'].createElement('col', { width: '14.29%' }),
                    _react2['default'].createElement('col', { width: '14.29%' }),
                    _react2['default'].createElement('col', { width: '14.29%' }),
                    _react2['default'].createElement('col', { width: '14.29%' })
                ),
                _react2['default'].createElement(
                    'caption',
                    null,
                    _react2['default'].createElement(Glyph, {
                        className: 'prev',
                        icon: 'icon-arrow-left-small',
                        onClick: this.props.prev
                    }),
                    _react2['default'].createElement(
                        'h3',
                        { onClick: this.props.switchView },
                        this.props.caption
                    ),
                    _react2['default'].createElement(Glyph, {
                        className: 'next',
                        icon: 'icon-arrow-right-small',
                        onClick: this.props.next
                    })
                ),
                _react2['default'].createElement(
                    'thead',
                    null,
                    _react2['default'].createElement(
                        'tr',
                        null,
                        this.props.view === 'month' ? this.props.localeLabels.day.map(function (day) {
                            return _react2['default'].createElement(
                                'th',
                                null,
                                day
                            );
                        }) : null
                    )
                ),
                _react2['default'].createElement(
                    'tbody',
                    null,
                    this.props.children
                )
            );
        }
    }]);

    return CalendarView;
})(_react2['default'].Component);

CalendarView.propTypes = {
    caption: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
    localeLabels: _propTypes2['default'].object,
    next: _propTypes2['default'].func,
    prev: _propTypes2['default'].func,
    switchView: _propTypes2['default'].func,
    view: _propTypes2['default'].oneOf(['month', 'year', 'decade'])
};

var Calendar = (function (_React$Component2) {
    _inherits(Calendar, _React$Component2);

    function Calendar(props) {
        _classCallCheck(this, Calendar);

        _get(Object.getPrototypeOf(Calendar.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Calendar';

        var date = this.getDate(this.props.date && this.props.date.start) || new Date();

        this.state = {
            view: 'month',
            month: date.getMonth() + 1,
            year: date.getFullYear()
        };
    }

    _createClass(Calendar, [{
        key: 'getDate',
        value: function getDate(date) {
            if (date && date.year && date.month && date.day) {
                return new Date(date.year, date.month - 1, date.day);
            }

            return null;
        }
    }, {
        key: 'onClick',
        value: function onClick(_ref) {
            var month = _ref.month;
            var year = _ref.year;
            var view = _ref.view;

            var nextMonth = month || this.state.month;
            var nextYear = year || this.state.year;
            var nextView = view || this.state.view;

            if (month > 12) {
                nextYear += 1;
                nextMonth = 1;
            } else if (month < 1) {
                nextYear -= 1;
                nextMonth = 12;
            }

            this.setState({
                month: nextMonth,
                year: nextYear,
                view: nextView
            });
        }
    }, {
        key: 'createDecade',
        value: function createDecade() {
            var localeLabels = this.props.localeLabels;

            var rows = [];
            var data = [];

            for (var year = this.state.year - 6; year <= this.state.year + 5; year++) {
                if (data.length == 3) {
                    data.push(_react2['default'].createElement(
                        'td',
                        { id: year, key: year },
                        _react2['default'].createElement(
                            'a',
                            { onClick: this.onClick.bind(this, { year: year, view: 'year' }) },
                            year
                        )
                    ));

                    rows.push(_react2['default'].createElement(
                        'tr',
                        { key: year },
                        data
                    ));
                    data = [];
                } else {
                    data.push(_react2['default'].createElement(
                        'td',
                        { id: year, key: year },
                        _react2['default'].createElement(
                            'a',
                            { onClick: this.onClick.bind(this, { year: year, view: 'year' }) },
                            year
                        )
                    ));
                }
            }

            return _react2['default'].createElement(
                CalendarView,
                {
                    localeLabels: localeLabels,
                    view: this.state.view,
                    caption: this.state.year - 6 + ' - ' + (this.state.year + 5),
                    prev: this.onClick.bind(this, {
                        year: this.state.year - 12
                    }),
                    next: this.onClick.bind(this, {
                        year: this.state.year + 12
                    }),
                    switchView: function (event) {
                        return event.preventDefault();
                    }
                },
                rows
            );
        }
    }, {
        key: 'createYear',
        value: function createYear() {
            var localeLabels = this.props.localeLabels;

            var rows = [];
            var data = [];

            for (var month = 1; month <= localeLabels.shortMonth.length; month++) {
                if (month % 4 === 0) {
                    data.push(_react2['default'].createElement(
                        'td',
                        { id: month, key: month },
                        _react2['default'].createElement(
                            'a',
                            { onClick: this.onClick.bind(this, { month: month, view: 'month' }) },
                            localeLabels.shortMonth[month - 1]
                        )
                    ));

                    rows.push(_react2['default'].createElement(
                        'tr',
                        { key: month },
                        data
                    ));
                    data = [];
                } else {
                    data.push(_react2['default'].createElement(
                        'td',
                        { id: month, key: month },
                        _react2['default'].createElement(
                            'a',
                            { onClick: this.onClick.bind(this, { month: month, view: 'month' }) },
                            localeLabels.shortMonth[month - 1]
                        )
                    ));
                }
            }

            return _react2['default'].createElement(
                CalendarView,
                {
                    localeLabels: localeLabels,
                    view: this.state.view,
                    caption: this.state.year,
                    prev: this.onClick.bind(this, {
                        year: this.state.year - 1
                    }),
                    next: this.onClick.bind(this, {
                        year: this.state.year + 1
                    }),
                    switchView: this.onClick.bind(this, { view: 'decade' })
                },
                rows
            );
        }
    }, {
        key: 'createMonth',
        value: function createMonth() {
            var dayCount = 0;
            var dayStarted = false;
            var rows = [];
            var data = [];
            var dayOne = new Date(this.state.year, this.state.month - 1, 1).getDay();
            var totalDays = new Date(this.state.year, this.state.month, 1, -1).getDate();
            var weeks = Math.ceil((dayOne + totalDays) / 7);

            var localeLabels = this.props.localeLabels;

            for (var week = 0; week < weeks; week++) {
                //Reset the data
                data = [];

                for (var day = 0; day < 7; day++) {
                    if (dayCount === totalDays + 1) {
                        break;
                    }
                    if (day === dayOne && dayCount < 1 && dayStarted === false) {
                        dayCount++;
                        data.push(this.createDay(dayCount));
                        dayCount++;
                        dayStarted = true;
                    } else if (dayCount === 0 && dayStarted === true) {
                        data.push(_react2['default'].createElement('td', null));
                        dayCount++;
                        break;
                    } else if (dayCount >= 1 && dayStarted === true) {
                        data.push(this.createDay(dayCount));
                        dayCount++;
                    } else {
                        data.push(_react2['default'].createElement('td', null));
                    }
                }

                rows.push(_react2['default'].createElement(
                    'tr',
                    { key: week },
                    data
                ));
            }

            return _react2['default'].createElement(
                CalendarView,
                {
                    localeLabels: localeLabels,
                    view: this.state.view,
                    caption: localeLabels.month[this.state.month - 1] + ' ' + this.state.year,
                    prev: this.onClick.bind(this, {
                        month: this.state.month - 1
                    }),
                    next: this.onClick.bind(this, {
                        month: this.state.month + 1
                    }),
                    switchView: this.onClick.bind(this, { view: 'year' })
                },
                rows
            );
        }
    }, {
        key: 'createDay',
        value: function createDay(day) {
            var _state = this.state;
            var month = _state.month;
            var year = _state.year;

            var dateKey = new Date(year, month - 1, day).toISOString().replace(/\T.*/, '');
            var selectedStyle = '';
            var start = this.getDate(this.props.date.start);
            var end = this.getDate(this.props.date.end);
            var startKey = start && start.toISOString().replace(/\T.*/, '');
            var endKey = end && end.toISOString().replace(/\T.*/, '');

            return _react2['default'].createElement(
                'td',
                {
                    id: dateKey,
                    className: (0, _classnames2['default'])({
                        'selected start': startKey === dateKey,
                        'selected end': endKey === dateKey,
                        range: dateKey >= startKey && dateKey < endKey,
                        end: start && !end,
                        first: day === 1
                    }),
                    key: dateKey
                },
                _react2['default'].createElement(
                    'a',
                    { onClick: this.onChange.bind(this, { day: day, month: month, year: year }, dateKey) },
                    day
                )
            );
        }
    }, {
        key: 'onChange',
        value: function onChange(date, dateKey) {
            var selectedDate = this.cloneObject(this.props.date);
            var start = this.getDate(selectedDate.start);
            var end = this.getDate(selectedDate.end);
            var startKey = start && start.toISOString().replace(/\T.*/, '');
            var endKey = end && end.toISOString().replace(/\T.*/, '');

            if (this.props.type === 'datePicker') {
                selectedDate.start = date;
                selectedDate.end = null;
            } else if (this.props.type === 'dateRange') {
                if (selectedDate.start === null && selectedDate.end === null) {
                    selectedDate.start = date;
                } else if (selectedDate.start && selectedDate.end) {
                    selectedDate.start = date;
                    selectedDate.end = null;
                } else if (selectedDate.end === null && dateKey < startKey) {
                    selectedDate.end = selectedDate.start;
                    selectedDate.start = date;
                } else {
                    selectedDate.end = date;
                }
            }

            this.props.onChange(selectedDate);
        }
    }, {
        key: 'viewRenderer',
        value: function viewRenderer(view) {
            switch (view) {
                case 'month':
                    return this.createMonth();
                case 'year':
                    return this.createYear();
                case 'decade':
                    return this.createDecade();
                default:
                    return this.createMonth();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var localeLabels = this.props.localeLabels;

            return _react2['default'].createElement(
                'div',
                { className: 'Calendar' },
                this.viewRenderer(this.state.view)
            );
        }
    }]);

    return Calendar;
})(_react2['default'].Component);

Calendar.propTypes = {
    className: _propTypes2['default'].string,
    date: _propTypes2['default'].object,
    localeLabels: _propTypes2['default'].object,
    onChange: _propTypes2['default'].func.isRequired,
    type: _propTypes2['default'].oneOf(['dateRange', 'datePicker'])
};

Calendar.defaultProps = {
    localeLabels: {
        shortMonth: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    },
    type: 'datePicker',
    date: {
        start: null,
        end: null
    }
};

(0, _reactMixin2['default'])(Calendar.prototype, Mixin);

module.exports = Calendar;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Calendar.js
// module id = 956
// module chunks = 0 1